





















import deepmerge from 'deepmerge';
import { Component } from 'vue-property-decorator';
import { SwiperOptions } from './types';
import { BaseSlider } from './BaseSlider';

@Component({
    components: {
        Swiper: () =>
            import(
                /* webpackChunkName: "Swiper" */
                /* webpackMode: "lazy" */ 'vue-awesome-swiper'
            ).then(({ Swiper }) => Swiper),

        SwiperSlide: () =>
            import(
                /* webpackChunkName: "Swiper" */
                /* webpackMode: "lazy" */ 'vue-awesome-swiper'
            ).then(({ SwiperSlide }) => SwiperSlide),
    },
})
export default class BannerSlider extends BaseSlider {
    /**
     *
     */
    public mounted() {
        const swiperOptionsDefault: SwiperOptions = {
            effect: 'fade',
            longSwipesRatio: 0.3,
            preloadImages: false,
            loop: true,
            speed: 500,
            grabCursor: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
        };

        this.swiperOptions = deepmerge(swiperOptionsDefault, this.$props.sliderOptions);
    }
}
